<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix" style="min-height: 270px">
      <div id="main_area">
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>年度：</td>
                  <td>
                    <select v-model="form.syear">
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>假日名稱：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.holiday" />
                  </td>
                </tr>
                <tr>
                  <td>日期：</td>
                  <td>
                    <DatePicker
                      v-model="form.sdate"
                      format="YYYMMDD"
                      :popupClass="inline"
                      :isTaiwanYear="true"
                      clearable
                      placeholder="請輸入/選擇日期"
                    /><br />
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <input
                      type="submit"
                      class="btn"
                      value="查詢"
                      @click="
                        () => {
                          this.form.currentpage = 1;
                          this.form.pagesize = 10;
                          this.doQuery();
                        }
                      "
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="新增"
                      @click="btnAdd()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="匯入"
                      @click="btnImport()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="重填"
                      @click="doClear()"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- 查詢結果開始-->
    <div class="information">
      <table width="100%">
        <tbody>
          <tr>
            <td>
              <button class="btn" @click="btnAllCheck()">全選</button>
              <button class="btn" @click="btnCancelCheck()">取消</button>
              <button class="btn" @click="btnDeleteAll()">整批刪除</button>
            </td>
            <td v-if="grid.paginaiton" align="right">
              <input
                type="button"
                value="<<"
                class="btn"
                style="height: 28px"
                @click="form.currentpage = grid.paginaiton.pageNo - 1"
                v-show="grid.paginaiton.pageNo > 1"
              />
              <span
                v-for="(data, index) in grid.paginaiton.pages"
                :key="index"
                style="cursor: pointer"
                :style="
                  grid.paginaiton.pageNo == data ? 'color:red' : 'color:black'
                "
                @click="form.currentpage = parseInt(data)"
              >
                {{ grid.paginaiton.pageNo == data ? "[" + data + "]" : data }}
              </span>
              <input
                type="button"
                class="btn"
                value=">>"
                style="height: 28px"
                v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                @click="form.currentpage = grid.paginaiton.pageNo + 1"
              />
              ［每頁<input
                type="text"
                v-model.number.lazy="form.pagesize"
                size="2"
                maxlength="4"
              />

              <input type="button" class="btn" value="筆" />，第<input
                type="text"
                v-model.number.lazy="form.currentpage"
                size="2"
                maxlength="4"
              />
              <input type="button" class="btn" value="頁" />，共
              {{ grid.paginaiton.totalPage }} 頁
              {{ grid.paginaiton.totalCount }} 筆］
            </td>
          </tr>
        </tbody>
      </table>
      <div class="active">
        <div class="table_scroll2">
          <table width="1060" class="itable">
            <thead>
              <tr>
                <th style="min-width: 80px">選取</th>
                <th style="min-width: 80px">操作</th>
                <th style="min-width: 80px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('HOLI_DATE', Sort);
                      }
                    "
                    >日期</u
                  >
                </th>
                <th style="min-width: 80px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('DAY_NAME', Sort);
                      }
                    "
                    >假日名稱</u
                  >
                </th>
                <th style="width: 80px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('NOTE', Sort);
                      }
                    "
                    >備註</u
                  >
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in grid.gridDatas" :key="index">
                <td width="1%" align="center">
                  <input
                    type="checkbox"
                    v-model="form.Selected"
                    :value="{ pkno: data.pkno }"
                  />
                </td>
                <td width="1%" align="center">
                  <input
                    type="button"
                    class="btn"
                    @click="btnEdit(data)"
                    value="編"
                  />
                </td>
                <td>{{ data.holiDateStr }}</td>
                <td>{{ data.dayName }}</td>
                <td>{{ data.note }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- 查詢結果結束-->
    <PdisFooter />

    <DetailModal
      v-model="DetailModal.show"
      :title="DetailModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>日期</td>
                <td>
                  <DatePicker
                    v-model="DetailModal.form.holidate"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                  /><br />
                </td>
                <td>假日名稱</td>
                <td>
                  <input type="text" v-model="DetailModal.form.dayname" />
                </td>
              </tr>
              <tr>
                <td>備註</td>
                <td colspan="3">
                  <p>
                    <input
                      type="text"
                      v-model="DetailModal.form.note"
                      size="80"
                      maxlength="80"
                    />
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="存檔"
                        @click="btnDetailSave()"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="btnDetailClear()"
                        :disabled="DetailModal.modifyType == 'U'"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </DetailModal>

    <ImportModal
      v-model="ImportModal.show"
      :title="ImportModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>上傳檔案</td>
                <td>
                  <input
                    type="file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    @change="ImportModalOnFileChange"
                  />
                  <input
                    type="submit"
                    class="btn"
                    value="匯入"
                    @click="ImportModalBtnImport()"
                  />
                </td>
              </tr>
              <tr>
                <td>說明</td>
                <td>
                  <p>
                    【使用說明】：<br />
                    1. 上傳格式說明<br />
                    2.請先下載此範本<a
                      href="/PdpsCli/download/S401_Sample.xlsx"
                      target="_blank"
                      >sample.xlsx</a
                    ><br />
                    3.依範本方式輸入需要的各項資料<br />
                    4.儲存檔案 (副檔名需存成.xlsx)<br />
                    5.再按下上方的「選擇檔案」按鈕，選擇剛儲存的檔案<br />
                    6.按下「匯入」按鈕<br />
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </ImportModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenuIndex, getMenu, logOut } from "@/config/util.js";
import {
  S401_SearchGrid,
  S401_ReSearchGrid,
  S401_Delete,
  S401_Detail,
  S401_DetailAddSave,
  S401_DetailEditSave,
  S401_Import,
} from "@/service/api.js";
export default {
  name: "S401",
  data: function () {
    return {
      pageData: {
        MenuIndex: 6,
        MenuName: "",
        PrgName: "S401",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      Order: "",
      Sort: "",
      form: {
        syear: "",
        holiday: "",
        sdate: "",
        pagesize: 10,
        currentpage: 1,
        Selected: [],
        allSelected: false,
      },
      dropDownList: {
        syears: [],
      },
      grid: {},
      DetailModal: {
        show: false,
        title: "S401 年度假日管理",
        form: {
          pkno: "",
          dayname: "",
          holidate: "",
          note: "",
          userid: "", //self.loginInfo.id,
        },
        modifyType: "", //"I,U"
        dropDownList: {
          syears: [],
        },
        PreData: {},
      },
      ImportModal: {
        show: false,
        title: "S401 年度假日管理-匯入",
        form: {
          updloaD_FILE: "",
          dropDownList: {
            syears: [],
          },
        },
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Alert: VueModal,
    ImportModal: VueModal,
    DetailModal: VueModal,
    DatePicker: VueDatepicker,
  },
  methods: {
    ExportModalGetSyearDropDownList: function () {
      let syears = [];
      for (
        let i = new Date().getFullYear() - 1910;
        i > new Date().getFullYear() - 1910 - 4;
        i--
      ) {
        syears.push(i.toString());
      }
      return syears;
    },
    GetSyearDropDownList: function () {
      let syears = [""];
      const startYear = 99; //民國99年
      for (let i = startYear; i <= new Date().getFullYear() - 1910; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    //第一頁查詢
    doQuery: function () {
      const self = this;
       //清空
      self.Order = "";
      self.Sort = "";
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        syear: self.form.syear,
        holiday: self.form.holiday,
        sdate: self.form.sdate
          ? self.$moment(self.form.sdate).format("YYYY/MM/DD")
          : "",
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S401_SearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "HOLI_DATE";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        syear: self.form.syear,
        holiday: self.form.holiday,
        sdate: self.form.sdate
          ? self.$moment(self.form.sdate).format("YYYY/MM/DD")
          : "",
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      S401_ReSearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //第一頁重填
    doClear: function () {
      this.form = {
        idn: "",
        name: "",
        jobstatus: "",
        Selected: [],
        currentpage: 1,
        pagesize: 10,
      };
    },
    //全選
    btnAllCheck: function () {
      const self = this;
      self.form.Selected = [];
      if (!this.allSelected) {
        self.grid.gridDatas.forEach((g) =>
          self.form.Selected.push({ pkno: g.pkno })
        );
      }
    },
    //取消
    btnCancelCheck: function () {
      const self = this;
      self.form.Selected = [];
    },
    //第一頁新增
    btnAdd: function () {
      const self = this;
      self.DetailModal.PreData = {};
      self.btnDetailClear();
      self.DetailModalInit();
      self.DetailModal.modifyType = "I";
      self.DetailModal.title = "S401 年度假日管理-新增";
      self.DetailModal.show = true;
    },
    //第一頁匯入
    btnImport: function () {
      const self = this;
      self.ImportModal.show = true;
      self.ImportModal.form.updloaD_FILE = "";
    },
    //第一頁匯出
    btnExport: function () {
      const self = this;
      self.ExportModal.show = true;
      self.ExportModalBtnClear();
      self.ExportModal.dropDownList.syears = self.GetSyearDropDownList();
    },
    //gird
    //第一頁編
    btnEdit: function (data) {
      const self = this;
      self.DetailModal.PreData = data;
      self.getDetailData();
      self.DetailModalInit();
      self.DetailModal.modifyType = "U";
      self.DetailModal.title = "S401 年度假日管理-編輯";
      self.DetailModal.show = true;
    },
    //第一頁刪
    btnDelete: function (data) {
      const self = this;
      let postData = {
        pkno: data.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "刪",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S401_Delete(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["刪除成功"];
          self.Alert.BtnConfirm = () => {
            self.doQuery();
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["刪除失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    btnDeletefunc: function (data) {
      const self = this;
      S401_Delete({
        pkno: data.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "整批刪除",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        if (rData.result) {
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["刪除失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第一頁整批刪除按紐
    btnDeleteAll: function () {
      const self = this;

      if (self.form.Selected.length) {
        self.form.Selected.forEach((g) => {
          self.btnDeletefunc({ pkno: g.pkno });
        });
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["刪除成功"];
        self.Alert.BtnConfirm = () => {
          self.doQuery();
          self.Alert.show = false;
          self.form.Selected = [];
        };
        //self.modal.show = true;
        //self.btnModalClear();
        //self.modalGetOnJob();
      } else {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["請先勾選移轉名單!"];
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
      }
    },
    //第二頁明細init
    DetailModalInit: function () {
      const self = this;
      self.GetSyearDropDownList();
    },
    //西元日期轉民國日期
    ToTaiwanCalendarDate: function (dateString) {
      const dateMoment = this.$moment(dateString);
      return (
        parseInt(dateMoment.format("YYYY")) - 1911 + dateMoment.format("MMDD")
      );
    },
    //第二頁明細內容 API
    getDetailData: function () {
      const self = this;
      let postData = {
        pkno: self.DetailModal.PreData.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "編",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S401_Detail(postData).then((rData) => {
        if (rData.result) {
          self.DetailModal.grid = rData.returnObject;
          self.DetailModal.form = {
            dayname: self.DetailModal.grid.dayName,
            holidate: self.$moment(self.DetailModal.grid.holiDate)._d,
            year: self.DetailModal.grid.year,
            note: self.DetailModal.grid.note,
            userid: "", //self.loginInfo.id,
          };
        }
      });
    },
    //第二頁明細新增 API
    S401_DetailAddSave: function () {
      const self = this;
      let postData = {
        pkno: 0,
        dayname: self.DetailModal.form.dayname,
        holidate: self
          .$moment(self.DetailModal.form.holidate)
          .format("YYYY/MM/DD"),
        year: self.DetailModal.form.year,
        note: self.DetailModal.form.note,
        userid: "", //self.loginInfo.id
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細新增",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      console.log(JSON.stringify(postData));
      S401_DetailAddSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["新增成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = [rData.messages[0]];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
        //console.log(rData);
      });
    },
    //第二頁明細修改 API
    S401_DetailEditSave: function () {
      const self = this;
      let postData = {
        pkno: self.DetailModal.PreData.pkno,
        dayname: self.DetailModal.form.dayname,
        holidate: self
          .$moment(self.DetailModal.form.holidate)
          .format("YYYY/MM/DD"),
        year: self.DetailModal.form.year,
        note: self.DetailModal.form.note,
        userid: "", //self.loginInfo.id
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細修改",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      console.log(JSON.stringify(postData));
      S401_DetailEditSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["修改成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = [rData.messages[0]];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁按紐明細存檔
    btnDetailSave: function () {
      const self = this;
      let errorMsg = [];
      if (self.DetailModal.form.holidate == "") {
        errorMsg.push("請填寫假日日期");
      }
      if (self.DetailModal.form.dayname.trim() == "") {
        errorMsg.push("請填寫假日名稱");
      }
      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }
      if (self.DetailModal.modifyType == "I") {
        self.S401_DetailAddSave();
      } else if (self.DetailModal.modifyType == "U") {
        self.S401_DetailEditSave();
      }
    },
    //第二頁明細重填
    btnDetailClear: function () {
      const self = this;
      self.DetailModal.form = {
        dayname: "",
        holidate: "",
        year: "",
        note: "",
      };
    },
    //匯入頁
    ImportModalOnFileChange: function (event) {
      const self = this;
      self.ImportModal.form.updloaD_FILE = event.target.files[0];
    },
    //匯入頁 按紐匯入
    ImportModalBtnImport: function () {
      const self = this;
      if (self.ImportModal.form.updloaD_FILE) {
        let formData = new FormData();
        formData.append("UPDLOAD_FILE", self.ImportModal.form.updloaD_FILE);
        formData.append("LogInfo.Id", self.loginInfo.id);
        formData.append("LogInfo.PrgCode", self.pageData.PrgName);
        formData.append("LogInfo.ActCd", "匯入");
        formData.append("LogInfo.Token", self.loginInfo.token);
        formData.append("LogInfo.ServiceUnit", self.pageData.ServiceUnit);
        S401_Import(formData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = [rData.messages[0]]; //["匯入成功"];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.doQuery();
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = [rData.messages[0]]; //["匯入失敗"];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
            };
          }
        });
      } else {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["請先選取匯入檔案"];
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
      }
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.dropDownList.syears = self.GetSyearDropDownList();
  },
  watch: {
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
